// @codekit-prepend (quiet) "../../../../../../_common/js/polyfills/Object.values.js"
// @codekit-prepend (quiet) "../../../../../../_common/js/polyfills/polyfill.object-fit.js"
// @codekit-prepend (quiet) "../../../../../../_common/js/polyfills/css-vars-ponyfill.min.js"
// @codekit-prepend (quiet) "../../../../../../_common/js/polyfills/promise-polyfill.min.js"
// @codekit-prepend (quiet) "../../../../../../_common/js/vendor/ua-parser.js"
// @codekit-prepend "../../../../../../_common/js/concat/managers/VTT"
// @codekit-prepend "../../../../../../_common/js/concat/managers/Bookmarks"


( function( window, document, c, undefined ) 
{
  "use strict";

  // shortcut
  let Log = c.utils.Log;


  //============================================================================
  //
  // CLASS: Omnia
  // 
  //============================================================================
  var Omnia = ( function()
  {
    
    //--------------------------------------------------------------------------
    // internal properties
    //--------------------------------------------------------------------------

    // vars
    var _id,
        _data,
        _state                   = c.Megaphone.States.AddonStates.READY,
        _mi                      = c.Megaphone.MediaInterface,
        _bs                      = c.Megaphone.Signals.BroadcastSignals,
        _settings                = c.Megaphone.Settings,
        _env                     = c.Megaphone.Environment,
        _timers                  = {
          hide                   : undefined,
          scrollend              : undefined
        },
        _throttledBroadcast,
        _throttledSeekCB,
        _throttledVolumeCB,
        _isShowing               = false,
        _isScrolling             = false,
        _isScrubbingSeek         = false,
        _isScrubbingVolume       = false,
        _isTouchEvent            = false,
        _isKeyboardEvent         = false,
        _touch                   = {
          isDragging             : false,
          x                      : undefined,
          y                      : undefined
        },
        _mouse                   = {
          isDown                 : false,
          x                      : undefined,
          y                      : undefined
        },
        _duration                = undefined,
        _playerState             = {
          PLAYING                : 1,
          PAUSED                 : 2,
          BUFFERING              : 3
        },
        _capabilities            = {
          fullscreen             : true,
          bookmarks              : false,
          captions               : false,
          seekthumbs             : false,
          settings               : false,
          vr                     : false,
          gyro                   : false
        },
        _css                     = {
          toggles                : {
            show                 : "show",
            focused              : "focused",
            captions_select      : "captions-select",
            captions_on          : "captions-on",
            bookmarks_on         : "bookmarks-on",
            bookmarks_always_on  : "bookmarks-always-on",
            settings_select      : "settings-select"
          },
          capabilities           : {
            fullscreen           : "fullscreen",
            seekthumbs           : "seekthumbs",
            captions             : "captions",
            bookmarks            : "bookmarks",
            settings             : "settings",
            vr                   : "vr",
            gyro                 : "gyro"
          },
          state                  : {
            playing              : "playing",
            buffering            : "buffering",
            paused               : "paused"
          }
        },
        _tpl                     = {
          btnAddon               : undefined,
          captionTrackCtnr       : undefined,
          captionItem            : undefined,
          captionTrackSelect     : undefined,
          bookmarkItem           : undefined,
          qualityLevelSelect     : undefined
        },
        _vtt                     = c.managers.VTT,
        _qualitiesAdded          = {},
        _bookmarks               = c.managers.Bookmarks,
        _timeline                = new TimelineMax( { paused:true } ),
        _listCaptionLangBtns     = [], 
        _listBookmarkItemBtns    = [], 
        _listQualityLevelBtns    = [],
        _listAddonBtns           = [], 

        // _shouldUseGyroFrame      = false,

        // selectors
        _$ctnr,
        _$debug,
        _$chrome,
        _$captionCtnr,
        _$captionTracks,
        _$captionTrackSelectCtnr,
        _$captionTrackSelectList,
        _$bookmarkCtnr,
        _$settingsCtnr,
        _$qualityLevelSelectCtnr,
        _$qualityLevelSelectList,
        _$timelineCtnr,
        _$seekBar,
        _$progressBar,
        _$seekingBar,
        _$loadedBar,
        _$scrubCtnr,
        _$seekThumb,
        _$seekThumbPtr,
        _$seekThumbImgCtnr,
        _$seekThumbImg,
        _$seekThumbTime,
        _$btnSeekScrubber,
        _$mediaBtnsCtnr,
        _$volumeCtnr,
        _$volumeBarsCtnr,
        _$btnPlaypause,
        _$btnVolume,
        _$btnVolumeScrubber,
        _$volProgressBar,
        _$volSeekBar,
        _$btnFullscreen,
        _$btnCaptions,
        _$btnCaptionsOff,
        _$btnBookmarks,
        _$btnSettings,
        _$btnSeekforw,
        _$btnSeekback,
        _$playscreenCtnr,
        _$btnPlayScreen,
        _$addonBtnsCtnr,
        _$totalTime,
        _$currentTime,
        _$remainTime,
        _$logo,
        _$autoplayMutedCtnr,
        _$btnAutoplayUnmute,
        _$vrCtnr,
        _$vrIndicatorCtnr,
        _$btnCenterFov,
        _$btnPermitGyro,
        _$btnToggleGyro,
        _$btnDummy;


    //--------------------------------------------------------------------------
    // public
    //--------------------------------------------------------------------------
    function init( data ) 
    {
      Log( "Omnia :: init(), Called." );

      // HTML CHECK
      _$ctnr = c.$( "#omnia-ctnr" );
      if( _$ctnr.length === 0 )
      {
        _state = c.Megaphone.States.AddonStates.FAILED;
        c.Megaphone.Signals.AddonSignals.ERRORED.dispatch( "Omnia.js :: HTML has not been added to the DOM." );
        return; 
      }
      // library check
      if( typeof window.WebVTT === "undefined" )
      {
        _state = c.Megaphone.States.AddonStates.FAILED;
        c.Megaphone.Signals.AddonSignals.ERRORED.dispatch( "Omnia.js :: vtt.js library is required." );
        return; 
      }

      // ************************
      // DEBUGGING
      // _$debug = c.$( "<textarea></textarea>" );
      // _$ctnr.append( _$debug ).addClass( "debug" );
      // let _log = Log;
      // Log = function()
      //   {
      //     _$debug[0].innerHTML += ( _$debug[0].innerHTML !== "" ? "\n" : "" ) + Array.from( arguments ).join(" ");
      //     _$debug[0].scrollTop = _$debug[0].scrollHeight;
      //     _log.apply( this, arguments );
      //   }
      // ************************


      // validate incoming data
      _data = _validateData( data );

      // inits
      _initSelectors();
      _initTemplates();


      // update duration
      if( _mi.duration() > 0 )
        _updateDuration();
      _mi.DURATIONUPDATED.add( _updateDuration );


      // add add-on buttons
      for( var i = 0; i < _data.addon_buttons.length; i++ )
      {
        var btn = _data.addon_buttons[i];
        btn.label = btn.label || "";

        if( !!btn.aid && !!btn.icon )
        {
          //  create button from HTML
          var $btn = c.$( _tpl.btnAddon );
          $btn
            .attr( "data-aid", btn.aid )
            .attr( "aria-label", btn.label )
            .css({ "background-image" : `url("${btn.icon}")` })
            .on( "touchend mousedown", _onPointerdown_addonbtn );

          _listAddonBtns.push( $btn );
          _$addonBtnsCtnr.append( $btn );
        }
      }


      // handle logo or lack thereof
      if( _data.logo.src !== "" )
      {
        c.$( "img", _$logo ).attr( "src", _data.logo.src );
        if( _data.logo.href !== "" )
          c.$( "a", _$logo ).attr( "href", _data.logo.href );

        objectFit.polyfill({
          selector: '#omnia-ctnr .omnia-logo-ctnr img', // this can be any CSS selector
          fittype: 'contain', // either contain, cover, fill or none
          disableCrossDomain: 'true' // either 'true' or 'false' to not parse external CSS files.
        });          
      }
      else
        _$logo.remove();



      // *******************
      // update this later. ipad was not going fullscreen for non-360 videos in VideoJS
      // *******************
      // init fullscreen
      if( ( !c.Megaphone.MediaInterface.isFullscreenEnabled() && 
            !c.Megaphone.MediaInterface.isIOSFallbackFullscreenEnabled() ) ||
          // ( _mi.isVR() && _env.isIOS() ) )
          ( _env.isIOS() && typeof window.videojs !== "undefined" ) )
      {
        _capabilities.fullscreen = false;
      }



      var promises = [];

      // init promise for thumbnail track
      if( _data.seekthumbs.src !== "" )
      {
        Log( "  adding promise for seekthumbs..." );
        promises.push( _vtt.loadTrackFile( "seekthumbs", _vtt.types.SEEKTHUMBS, _data.seekthumbs.src ) );
      }


      // init promise for bookmarks
      if( _data.bookmarks.items.length )
      {
        // // add a promise for a working `_duration`
        // if( !_duration )
        // {
        //   promises.push( new Promise( function( resolve, reject ) {
        //     _mi.DURATIONUPDATED.addOnce( function() { resolve(); } );
        //   }));
        // }

        // a promise for the bookmarks
        Log( "  adding promise for bookmarks..." );
        promises.push( _bookmarks.addList( _data.bookmarks.items ) );
      }


      // init promises for all caption tracks
      var trackData = {};
      if( _data.captions.tracks.length )
      {
        for( i = 0; i < _data.captions.tracks.length; i++ )
        {
          var t = _data.captions.tracks[i];

          // validation check
          if( t.src === "" || t.label === "" || t.lang === "" ) { continue; }

          var id = t.lang;
          trackData[id] = t;

          // add a promise for each caption track
          Log( `  adding promise for caption file [${id}]...` );
          promises.push( _vtt.loadTrackFile( id, _vtt.types.CAPTIONS, t.src ) );
        }
      }


      // init promise for gyroscope handling
      if( _env.isGyroAllowed && !!c.Gyro )
      {
        Log( "  adding promise for gyro..." );
        promises.push( c.Gyro.child.init( "csi-mp" ) );
      }

      // handle promises (no need for then or catch -- we'll handle everything
      // in the finally accordingly)
      Promise.allSettled( promises )
        .then( function() {
          Log( "Omnia :: init(), promises.allSettled().then..." );

          var $btn;
          var captionTracks = _vtt.getTracksByType( _vtt.types.CAPTIONS );

          // Log( "Omnia :: init(), c.Gyro.state:", c.Gyro.child.state()  );

          // set capabilities
          _capabilities.seekthumbs      = ( _vtt.getTrack( "seekthumbs" ) !== null );
          _capabilities.captions        = ( captionTracks.length > 0 );
          _capabilities.bookmarks       = ( _bookmarks.items().length > 0 );
          _capabilities.vr              = _mi.isVR();
          _capabilities.gyro            = _env.isGyroAllowed && c.Gyro && c.Gyro.child.state() === c.Gyro.States.IDLE;

          Log( "Omnia :: init(), capabilities:", _capabilities );

          // handle fullscreen updates, if necessary
          if( !_capabilities.fullscreen )
          {
            _$btnFullscreen.prop( "disabled", true );
          }

          // handle seekthumbs, if necessary
          if( _capabilities.seekthumbs )
          {
            Log( "  handling seekthumbs..." );
            // add "bookmarks" as a capability (updates some UI in the CSS)
            _$ctnr.addClass( _css.capabilities.seekthumbs );
          }

          // handle captions, if necessary
          if( _capabilities.captions )
          {
            Log( "  handling captions..." );

            // enable captions/captions-off button
            _$btnCaptions.attr( "tabIndex", "0" );

            // only one caption track? update captions button to act as toggle
            if( captionTracks.length === 1 )
            {
              Log( "    only one caption track..." );

              // update aria tags on captions button
              _$btnCaptions.attr( "aria-label", "Closed Captions" );
              _$btnCaptions.removeAttr( "aria-controls" );
              _$btnCaptions.removeAttr( "aria-expanded" );

              // remove menu
              _$captionTrackSelectCtnr.remove();

              // build the caption track
              let ct = captionTracks[0];

              let $track = c.$( _tpl.captionTrackCtnr );
              $track.addClass( "selected" );
              _$captionCtnr.append( $track );

              // build captions for this language
              for( let j = 0; j < ct.cues.length; j++ )
              {
                let cap = ct.cues[j];
                let $cap = c.$( _tpl.captionItem );
                $cap.find( "span" )
                  .html( cap.text )

                $track.append( $cap );

                // build display captions on a TimelineMax instance
                _timeline.add( TweenMax.from( $cap, .001, { opacity: 0 } ), cap.startTime );
                _timeline.add( TweenMax.to( $cap, .001, { opacity: 0 } ), cap.endTime );
              }
            }

            // multiple caption tracks? populate the menu
            else
            {
              Log( "    multiple caption tracks..." );

              _$btnCaptionsOff.attr( "tabIndex", "0" );
              _listCaptionLangBtns.push( _$btnCaptionsOff );

              // loop through available caption tracks...
              for( i = 0; i < captionTracks.length; i++ )
              {
                let ct = captionTracks[i];
                // Log( "  i:", i, "ct:", ct );

                // add item to caption language select menu
                var $select = c.$( _tpl.captionTrackSelect );
                _$captionTrackSelectList.append( $select );

                // set caption lang button props
                $btn = $select.find( "button" );
                $btn
                  .attr( "data-id", ct.id )
                  .attr( "aria-label", trackData[ct.id].label + " Captions" )
                  .html( trackData[ct.id].label );
                _listCaptionLangBtns.push( $btn );

                // init caption track container
                let $track = c.$( _tpl.captionTrackCtnr );
                $track.attr( "data-id", ct.id );
                _$captionCtnr.append( $track );

                // build captions for this language
                for( var j = 0; j < ct.cues.length; j++ )
                {
                  let cap = ct.cues[j];
                  let $cap = c.$( _tpl.captionItem );
                  $cap.find( "span" )
                    .html( cap.text )

                  $track.append( $cap );

                  // build display captions on a TimelineMax instance
                  _timeline.add( TweenMax.from( $cap, .001, { opacity: 0 } ), cap.startTime );
                  _timeline.add( TweenMax.to( $cap, .001, { opacity: 0 } ), cap.endTime );
                }
              }

              // touchend/mousedown was causing a glitch on iphone where the caption select 
              // screen wouldn't scroll. Also, this touch/click handler is added down here 
              // after all items added so that the "off" button gets an action too.
              _$captionTrackSelectList.find( "button" ).on( "click", _onClick_captionselect );

              // update selector to use later when selecting a particular track              
              _$captionTracks = c.$( ".omnia-caption-track-ctnr", _$captionCtnr );
            }

            // add "captions" as a capability (updates some UI in the CSS)
            _$ctnr.addClass( _css.capabilities.captions );
          }

          // handle bookmarks, if necessary
          if( _capabilities.bookmarks )
          {
            Log( "  handling bookmarks..." );

            var items = _bookmarks.items();

            // enable bookmarks button
            _$btnBookmarks.attr( "tabIndex", "0" );

            // build bookmark list
            var $ul = c.$( "ul", _$bookmarkCtnr );
            for( i = 0; i < items.length; i++ )
            {
              var bm = _bookmarks.items()[i];
              var $bm = c.$( _tpl.bookmarkItem );

              var left = ( Math.round( bm.time / _duration * 10000 ) / 100 ).toString() + "%";
              $bm.css({
                "order" : i+1,
                "z-index" : i+1,
                "background-color" : _data.colors.bookmark_dot
                // "left" : left
              });

              // update UI
              $bm.find( "span.omnia-bookmark-item-label" )
                .html( bm.label );
              $bm.find( "span.omnia-bookmark-item-time" )
                .html( c.utils.SecsToTimecode( bm.time ) );
              $bm.find( "span.omnia-bookmark-item-icon" )
                .css({
                  "background-image" : `url('${bm.icon}')`
                });
              $ul.append( $bm );

              // set bookmark button props
              $btn = $bm.find( "button" );
              $btn
                .attr( "data-id", bm.id )
                .attr( "data-time", bm.time )
                .on( "touchstart click", _onPointerdown_bookmarkItem );
              _listBookmarkItemBtns.push( $btn );
            }

            // add "bookmarks" as a capability (updates some UI in the CSS)
            _$ctnr.addClass( _css.capabilities.bookmarks );

            // "auto_on" bookmarks?
            if( _data.bookmarks.auto_on )
            {         
              _$ctnr.addClass( _data.bookmarks.always_on 
                               ? _css.toggles.bookmarks_always_on
                               : _css.toggles.bookmarks_on );
            }
          }

          // handle vr, if necessary
          if( _capabilities.vr )
          {
            Log( "  handling vr..." );

            // show the 360 Media icon
            _$vrIndicatorCtnr.addClass( "show" );

            // add "gyro" as a capability (updates some UI in the CSS)
            _$ctnr.addClass( _css.capabilities.vr );
          }

          // handle gyro, if necessary
          if( _capabilities.gyro )
          {
            Log( "  handling gyro..." );

            _$btnPermitGyro.addClass( "show" );
            _$btnToggleGyro
              .addClass( "show" )
              .prop( "disabled", true );

            // add "gyro" as a capability (updates some UI in the CSS)
            _$ctnr.addClass( _css.capabilities.gyro );
          }


          // more inits now that all the DOM elements have been added
          _initTriggers();
          _initCSSVars();

          // all good in the hood!
          Log( "Omnia :: init(), Done." );
          _state = c.Megaphone.States.AddonStates.INITED;
          c.Megaphone.Signals.AddonSignals.INITED.dispatch( _id );
        });
    }
    //--------------------------------------------------------------------------
    function start() 
    {
      Log( "Omnia :: start(), called." );

      // start if previously inited
      if( _state != c.Megaphone.States.AddonStates.INITED )
        return;

      // trying to separate out 
      c.Megaphone.DOM.main.sel[0].addEventListener( "touchstart", _onTouchstart_csimain_capture, true );
      c.Megaphone.DOM.main.sel[0].addEventListener( "touchmove", _onTouchmove_csimain_capture, true );
      c.Megaphone.DOM.main.sel[0].addEventListener( "touchend", _onTouchend_csimain_capture, true );
      c.Megaphone.DOM.main.sel[0].addEventListener( "click", _onClick_csimain, true );
      c.Megaphone.DOM.main.sel.on( "mouseleave", _onMouseleave_ctnr );

      c.Megaphone.DOM.main.sel[0].addEventListener( "mousedown", _onMousedown_csimain, true );
      c.Megaphone.DOM.main.sel[0].addEventListener( "mousemove", _onMousemove_csimain, true );
      c.Megaphone.DOM.main.sel[0].addEventListener( "mouseup",   _onMouseup_csimain, true );

      c.$( document ).on( "keydown", _onKeydown_doc );


      // media interface actions
      _mi.LOADINGPROGRESSED.add( _onLoadingprogressed_mi );
      _mi.BUFFERINGSTARTED.add( _onBufferingstarted_mi );
      _mi.BUFFERINGENDED.add( _onBufferingended_mi );
      _mi.TIMEUPDATED.add( _onTimeupdated_mi );
      _mi.MUTED.add( _onMuted_mi );
      _mi.VOLUMEUPDATED.add( _onVolumeupdated_mi );
      _mi.PLAYINGSTATEENTERED.add( _onPlayingstateentered_mi );
      _mi.PAUSED.add( _onPaused_mi );
      _mi.SEEKENDED.add( _onSeekended_mi );
      _mi.COMPLETED.add( _onCompleted_mi );
      _mi.QUALITYLEVELSELECTED.add( _onQualitylevelselected_mi );
      _mi.QUALITYLEVELSADDED.add( _onQualitylevelsadded_mi );
      if( _mi.hasQualityLevels() )
        _onQualitylevelsadded_mi();
      if( _mi.quality() )
        _onQualitylevelselected_mi();

      // seek actions    
      _$timelineCtnr.on( "mousemove", _onMousemove_timeline );
      _$timelineCtnr.on( "mouseleave", _onMouseleave_timeline );
      _$timelineCtnr.on( "touchstart mousedown", _onPointerdown_timeline );
      _$btnSeekScrubber.on( "touchstart mousedown", _onPointerdown_seekscrubber );

      // volume actions
      _$volumeBarsCtnr.on( "mousedown", _onMousedown_volumebar );

      Log( "  muted:", _mi.muted() );
      _setVolumeIconUI();
      _setVolumeAria();

      // button actions
      _$btnVolume.on(     "touchstart click", _onPointerdown_volume );
      _$btnSeekback.on(   "touchstart click", _onPointerdown_seekback );
      _$btnPlaypause.on(  "touchstart click", _onPointerdown_playpause );
      _$btnSeekforw.on(   "touchstart click", _onPointerdown_seekforw );
      _$btnFullscreen.on( "touchstart click", _onPointerdown_fullscreen );
      _$btnCaptions.on(   "touchstart click", _onPointerdown_captions );
      _$btnSettings.on(   "touchstart click", _onPointerdown_settings );
      _$btnBookmarks.on(  "touchstart click", _onPointerdown_bookmarks );
      _$btnPlayScreen.on( "touchstart click", _onPointerdown_playscreen );

      _$btnAutoplayUnmute.on( "touchstart click", _onPointerdown_autoplaymuted );

      if( _vtt.getTracksByType( _vtt.types.CAPTIONS ).length > 1 )
        _$captionTrackSelectCtnr.on( "touchend click", _onPointerdown_captionTrackSelectCtnr );

      _$bookmarkCtnr.on(           "touchend click", _onPointerdown_bookmarkCtnr );
      _$settingsCtnr.on(           "touchend click", _onPointerdown_settingsCtnr );

      // handle keyboard nav
      window.addEventListener( 'focusin', _onFocusin_doc, true );

      // scrolling helper
      c.$( window ).on( "scroll", _onScroll_window );


      // Log( "  mi.isVR():", _mi.isVR() );

      // update UI when camera is updated
      _mi.VRCAMERAPOSITIONUPDATED.add( _onVrcamerapositionupdated_mi );

      // init vr buttons
      _$btnCenterFov.on( "touchstart click", _onPointerdown_centerfov );
      _$btnPermitGyro.on( "touchend click", _onPointerup_permitGyro );
      _$btnToggleGyro.on( "touchend click", _onPointerup_toggleGyro );

      // // auto hide the VR Indicator, unless permissions button is showing
      // if( !_$btnPermitGyro.hasClass( "show" ) || c.Megaphone.DOM.csi.sel.outerHeight() < 200 )
      // {
      //   setTimeout( () => {
      //       _$vrIndicatorCtnr.removeClass( "show" );
      //     }, _data.start_hide_delay * 1000 );
      // }

      // **** BAD UX : CHANGE THIS SOON ****
      // auto hide the VR Indicator AND the permissions button
      setTimeout( () => {
          _$vrIndicatorCtnr.removeClass( "show" );
          _$btnPermitGyro.removeClass( "show" );
        }, _data.vr_hide_delay * 1000 );


      // if muted by default...
      if( _mi.muted() )
      {
        Log( "  muted by default" );
        _$btnAutoplayUnmute.attr( "tabIndex", "0" );
        _$autoplayMutedCtnr.addClass( "show" );
      }

      // handle start_hide_delay
      if( _data.start_hide_delay > 0 )
      {
        _show();
        _delayedHide( _data.start_hide_delay );
      }


      Log( "Omnia :: start(), Ended." );
    }
    //--------------------------------------------------------------------------
    function resize() 
    {
      _setVideoProgressUI();
    }


    //--------------------------------------------------------------------------
    // private 
    //--------------------------------------------------------------------------

    // inits
    //--------------------------------------------------------------------------
    function _validateData( data )
    {
      Log( "Omnia :: _validateData()" );

      var d = data || {};

      // time, in seconds, to delay hiding of controls
      d.activity_hide_delay    = !isNaN( parseFloat( d.activity_hide_delay ) )
                               ? parseFloat( d.activity_hide_delay )
                               : 5;

      // time, in seconds, to delay hiding of controls
      d.start_hide_delay       = !isNaN( parseFloat( d.start_hide_delay ) )
                               ? parseFloat( d.start_hide_delay )
                               : -1;

      // time, in seconds, to delay hiding of 360 Media icon, if needed
      d.vr_hide_delay          = !isNaN( parseFloat( d.vr_hide_delay ) )
                               ? parseFloat( d.vr_hide_delay )
                               : d.start_hide_delay + 3;

      // time, in seconds, to skip with hitting the seek +/- buttons
      d.seek_delta             = !isNaN( parseFloat( d.seek_delta ) )
                               ? Math.abs( parseFloat( d.seek_delta ) )
                               : 5;

      // a client wanted any user activity to unmute the player. made this an 
      // option instead of hard coding in as a "feature"
      d.unmute_on_activity     = d.unmute_on_activity === true;                               


      // defaults are set up in the LESS file
      d.colors                 = d.colors                 || {};
      d.colors.mobile_play_btn = d.colors.mobile_play_btn || "";
      d.colors.seek_bar        = d.colors.seek_bar        || "";
      d.colors.loaded_bar      = d.colors.loaded_bar      || "";
      d.colors.progress_bar    = d.colors.progress_bar    || "";
      d.colors.seeking_bar     = d.colors.seeking_bar     || "";
      d.colors.bookmark_dot    = d.colors.bookmark_dot    || "";
      d.colors.caption_text    = d.colors.caption_text    || "";
      d.colors.caption_bg      = d.colors.caption_bg      || "";
      d.colors.caption_select  = d.colors.caption_select  || d.colors.seek_bar;
      d.colors.menu_select     = d.colors.menu_select     || d.colors.caption_select;
      d.colors.focus           = d.colors.focus           || d.colors.seek_bar;

      // logo file and link
      d.logo                   = d.logo                   || {};
      d.logo.src               = d.logo.src               || "";
      d.logo.href              = d.logo.href              || "";

      // triggered buttons for other addons
      d.addon_buttons          = d.addon_buttons          || [];

      // seekthumbs
      d.seekthumbs             = d.thumbnails             || {};
      d.seekthumbs.src         = d.thumbnails.src         || "";

      // captions
      d.captions               = d.captions               || {};
      d.captions.tracks        = d.captions.tracks        || [];

      // bookmarks 
      d.bookmarks              = d.bookmarks              || {};
      d.bookmarks.items        = d.bookmarks.items        || [];
      d.bookmarks.auto_on      = !_env.isMobile && d.bookmarks.auto_on   === true;
      d.bookmarks.always_on    = !_env.isMobile && d.bookmarks.always_on === true;

      return( d );
    }
    //--------------------------------------------------------------------------
    function _initSelectors() 
    {
      Log( "Omnia :: _initSelectors()" );

      _$chrome                  = c.$( ".omnia-chrome-ctnr", _$ctnr );

      _$timelineCtnr            = c.$( ".omnia-timeline-ctnr", _$ctnr );
      _$seekBar                 = c.$( ".omnia-seek-bar", _$timelineCtnr );
      _$progressBar             = c.$( ".omnia-progress-bar", _$timelineCtnr );
      _$seekingBar              = c.$( ".omnia-seeking-bar", _$timelineCtnr );
      _$loadedBar               = c.$( ".omnia-loaded-bar", _$timelineCtnr );

      _$scrubCtnr               = c.$( ".omnia-timeline-scrubbing-ctnr", _$ctnr );
      _$btnSeekScrubber         = c.$( ".omnia-scrubber-btn", _$scrubCtnr ); 
      _$seekThumb               = c.$( ".omnia-seek-thumb", _$scrubCtnr );
      _$seekThumbImgCtnr        = c.$( ".omnia-thumbnail-img-ctnr", _$seekThumb );    
      _$seekThumbImg            = c.$( "img", _$seekThumbImgCtnr );
      _$seekThumbTime           = c.$( "span", _$seekThumb );
      _$seekThumbPtr            = c.$( ".omnia-seek-thumb-pointer", _$seekThumb );

      _$logo                    = c.$( ".omnia-logo-ctnr", _$ctnr );

      _$currentTime             = c.$( ".omnia-time-current", _$ctnr );
      _$totalTime               = c.$( ".omnia-time-total", _$ctnr );
      _$remainTime              = c.$( ".omnia-time-remaining", _$ctnr );

      _$volumeCtnr              = c.$( ".omnia-volume-ctnr", _$ctnr );
      _$btnVolume               = c.$( ".omnia-volume-btn", _$volumeCtnr );
      _$volumeBarsCtnr          = c.$( ".omnia-volume-bars-ctnr", _$volumeCtnr );
      _$volSeekBar              = c.$( ".omnia-volume-bar", _$volumeCtnr );
      _$volProgressBar          = c.$( ".omnia-volume-progress-bar", _$volumeCtnr );
      _$btnVolumeScrubber       = c.$( ".omnia-scrubber-btn", _$volumeCtnr );

      _$mediaBtnsCtnr           = c.$( ".omnia-media-btn-ctnr", _$ctnr );
      _$btnSeekback             = c.$( ".omnia-seek-back-btn", _$mediaBtnsCtnr );
      _$btnPlaypause            = c.$( ".omnia-playpause-btn", _$mediaBtnsCtnr );
      _$btnSeekforw             = c.$( ".omnia-seek-forw-btn", _$mediaBtnsCtnr );
      _$btnFullscreen           = c.$( ".omnia-fullscreen-btn", _$mediaBtnsCtnr );
      _$btnCaptions             = c.$( ".omnia-captions-btn", _$mediaBtnsCtnr );
      _$btnBookmarks            = c.$( ".omnia-bookmarks-btn", _$mediaBtnsCtnr );
      _$btnSettings             = c.$( ".omnia-settings-btn", _$mediaBtnsCtnr );

      _$captionCtnr             = c.$( ".omnia-captions-ctnr", _$ctnr );
      _$captionTrackSelectCtnr  = c.$( ".omnia-captions-track-selection-ctnr", _$ctnr );
      _$captionTrackSelectList  = c.$( "ul", _$captionTrackSelectCtnr );
      _$btnCaptionsOff          = c.$( "button.omnia-caption-track-select-btn[data-id='off']", _$captionTrackSelectCtnr );

      _$bookmarkCtnr            = c.$( ".omnia-bookmarks-ctnr", _$ctnr );

      _$settingsCtnr            = c.$( ".omnia-settings-ctnr", _$ctnr );
      _$qualityLevelSelectCtnr  = c.$( ".omnia-quality-level-selection-ctnr", _$settingsCtnr );      
      _$qualityLevelSelectList  = c.$( "ul", _$qualityLevelSelectCtnr );

      _$addonBtnsCtnr           = c.$( ".omnia-addon-btn-ctnr", _$ctnr );

      _$playscreenCtnr          = c.$( ".omnia-playpause-screen", _$ctnr );
      _$btnPlayScreen           = c.$( ".omnia-playpause-screen-btn", _$playscreenCtnr );

      _$autoplayMutedCtnr       = c.$( ".omnia-autoplay-muted-ctnr", _$ctnr );
      _$btnAutoplayUnmute       = c.$( ".omnia-autoplay-unmute-btn", _$autoplayMutedCtnr );

      _$vrCtnr                  = c.$( ".omnia-vr-ctnr", _$ctnr );
      _$vrIndicatorCtnr         = c.$( ".omnia-vr-indicator-ctnr", _$vrCtnr );
      _$btnCenterFov            = c.$( ".omnia-vr-center-fov-btn", _$vrCtnr );
      _$btnPermitGyro           = c.$( ".omnia-vr-gyro-btn", _$vrCtnr );
      _$btnToggleGyro           = c.$( ".omnia-vr-gyro-toggle-btn", _$vrCtnr );

      _$btnDummy                = c.$( ".omnia-dummy-btn", _$ctnr );
    }
    //--------------------------------------------------------------------------
    function _initTemplates()
    {
      _tpl.btnAddon           = c.$( "#omnia-tpl-addon-item-btn" ).html();
      _tpl.captionTrackCtnr   = c.$( "#omnia-tpl-caption-track-ctnr" ).html();
      _tpl.captionItem        = c.$( "#omnia-tpl-caption-item" ).html();
      _tpl.captionTrackSelect = c.$( "#omnia-tpl-caption-track-select-item" ).html();
      _tpl.bookmarkItem       = c.$( "#omnia-tpl-bookmark-item" ).html();
      _tpl.qualityLevelSelect = c.$( "#omnia-tpl-quality-level-select-item" ).html();
    }
    //--------------------------------------------------------------------------
    function _initTriggers()
    {
      Log( "Omnia :: _initTriggers()" );

      // triggers for media buttons
      _$btnPlaypause.data     ( "trigger", _triggerPlaypauseBtn ); 
      _$btnSeekforw.data      ( "trigger", _triggerSeekforwBtn );
      _$btnSeekback.data      ( "trigger", _triggerSeekbackBtn );
      _$btnVolume.data        ( "trigger", _triggerVolumeBtn );
      _$btnFullscreen.data    ( "trigger", _triggerFullscreenBtn );
      _$btnCaptions.data      ( "trigger", _triggerCaptionsBtn );
      _$btnBookmarks.data     ( "trigger", _triggerBookmarksBtn );
      _$btnAutoplayUnmute.data( "trigger", _triggerAutoplayUnmuteBtn );
      _$btnCenterFov.data     ( "trigger", _triggerCenterFovBtn );
      _$btnPermitGyro.data    ( "trigger", _triggerPermitGyroBtn );
      _$btnToggleGyro.data    ( "trigger", _triggerToggleGyroBtn );

      // triggers for addon buttons
      _listAddonBtns.forEach( function( $btn, i ) {
        $btn.data( "trigger", _triggerAddonBtn );
      });

      // triggers for bookmarks
      _listBookmarkItemBtns.forEach( function( $btn, i ) {
        $btn.data( "trigger", _triggerBookmarkItemBtn );
      });

      // triggers for caption lang selects
      _listCaptionLangBtns.forEach( function( $btn, i ) {
        $btn.data( "trigger", _triggerCaptionLangBtn );
      });

      _listQualityLevelBtns.forEach( function( $btn, i ) {
        $btn.data( "trigger", _triggerQualityLevelBtn );
      })
    }
    //--------------------------------------------------------------------------
    function _initCSSVars()
    {
      var vars = {};

      if( _data.colors.mobile_play_btn !== "" )
        vars['--omnia-playpause-color'] = _data.colors.mobile_play_btn;

      if( _data.colors.seek_bar !== "" )
        vars['--omnia-seek-bar-color'] = _data.colors.seek_bar;

      if( _data.colors.loaded_bar !== "" )
        vars['--omnia-loaded-bar-color'] = _data.colors.loaded_bar;

      if( _data.colors.progress_bar !== "" )
        vars['--omnia-progress-bar-color'] = _data.colors.progress_bar;

      if( _data.colors.seeking_bar !== "" )
        vars['--omnia-seeking-bar-color'] = _data.colors.seeking_bar;

      if( _data.colors.bookmark_dot !== "" )
        vars['--omnia-bookmark-dot-color'] = _data.colors.bookmark_dot;

      if( _data.colors.caption_text !== "" )
        vars['--omnia-caption-text-color'] = _data.colors.caption_text;
      
      if( _data.colors.caption_bg !== "" )
        vars['--omnia-caption-bg-color'] = _data.colors.caption_bg;
      
      if( _data.colors.menu_select !== "" )
        vars['--omnia-menu-selected-color'] = _data.colors.menu_select;

      if( _data.colors.focus !== "" )
        vars['--omnia-focus-color'] = _data.colors.focus;

      // update for IE
      cssVars({
        variables: vars
      });
    }


    // trigger actions
    //--------------------------------------------------------------------------
    function _triggerPlaypauseBtn()
    {
      Log( "Omnia :: _triggerPlaypauseBtn()" );

      if( _mi.paused() )
      {
        // if( _isTouchEvent ) { _delayedHide( _data.activity_hide_delay / 2 ); }
        _bs.broadcast( "play-btn-" + _actionTrigger() );
        _mi.PLAYTRIGGERED.dispatch();
      }
      else
      {
        _bs.broadcast( "pause-btn-" + _actionTrigger() );
        _mi.PAUSETRIGGERED.dispatch();
      }
    }
    //--------------------------------------------------------------------------
    function _triggerVolumeBtn()
    {
      Log( "Omnia :: _triggerVolumeBtn()" );
      _data.unmute_on_activity = false;

      _bs.broadcast( "volume-btn-" + _actionTrigger() );
      _mi.MUTETRIGGERED.dispatch();
    }
    //--------------------------------------------------------------------------
    function _triggerAutoplayUnmuteBtn()
    {
      Log( "Omnia :: _triggerAutoplayUnmuteBtn()" );
      _killAutoplayMutedUI();
      _data.unmute_on_activity = false;

      _bs.broadcast( "autoplay-unmute-btn-" + _actionTrigger() );
      _mi.MUTETRIGGERED.dispatch();
    }
    //--------------------------------------------------------------------------
    function _triggerFullscreenBtn()
    {
      Log( "Omnia :: _triggerFullscreenBtn()" );
      _bs.broadcast( "fullscreen-btn-" + _actionTrigger() );
      _mi.FULLSCREENTRIGGERED.dispatch();
    }
    //--------------------------------------------------------------------------
    function _triggerSeekbackBtn()
    {
      Log( "Omnia :: _triggerSeekbackBtn()" );
      _bs.broadcast( "seek-back-btn-" + _actionTrigger() );
      _setSeekByDelta( -_data.seek_delta );     
    }
    //--------------------------------------------------------------------------
    function _triggerSeekforwBtn()
    {
      Log( "Omnia :: _triggerSeekforwBtn()" );
      _bs.broadcast( "seek-forward-btn-" + _actionTrigger );
      _setSeekByDelta( _data.seek_delta );     
    }
    //--------------------------------------------------------------------------
    function _triggerCaptionsBtn()
    {
      _bs.broadcast( "captions-toggle-btn-" + _actionTrigger );

      // only one caption track? toggle the track's visibility
      if( _vtt.getTracksByType( _vtt.types.CAPTIONS ).length === 1 )
      {
        _$ctnr.hasClass( _css.toggles.captions_on )
          ? _$ctnr.removeClass( _css.toggles.captions_on )
          : _$ctnr.addClass( _css.toggles.captions_on );
      }

      // multiple caption tracks? open/close the menu
      else
      {
        if( _$ctnr.hasClass( _css.toggles.captions_select ) )
        {
          _$ctnr.removeClass( _css.toggles.captions_select );  
          _$btnCaptions.attr( "aria-expanded", false );
        }
        else
        {
          _$ctnr.addClass( _css.toggles.captions_select );
          _$btnCaptions.attr( "aria-expanded", true );
        }
      }
    }
    //--------------------------------------------------------------------------
    function _triggerBookmarksBtn()
    {
      Log( "Omnia :: _triggerBookmarksBtn(), isTouchEvent:", _isTouchEvent );

      _bs.broadcast( "bookmarks-toggle-btn-" + _actionTrigger() );
         
      var cls = _data.bookmarks.always_on 
              ? _css.toggles.bookmarks_always_on
              : _css.toggles.bookmarks_on;

      if( _$ctnr.hasClass( cls ) )
      {
        _$ctnr.removeClass( cls )
      }
      else
      {
        _$ctnr.addClass( cls );
        _clearHideDelay();
      }  
    }
    //--------------------------------------------------------------------------
    function _triggerSettingsBtn()
    {
      Log( "Omnia :: _triggerSettingsBtn()" );

      _bs.broadcast( "settings-toggle-btn-" + _actionTrigger() );

      _$ctnr.hasClass( _css.toggles.settings_select ) 
        ? _$ctnr.removeClass( _css.toggles.settings_select )
        : _$ctnr.addClass( _css.toggles.settings_select );
    }
    //--------------------------------------------------------------------------
    function _triggerBookmarkItemBtn( $btn )
    {
      // validate $btn
      if( !$btn.hasClass( "omnia-bookmark-item-btn" ) )
        return;

      var id = $btn.attr( "data-id" );
      var time = parseFloat( $btn.attr( "data-time" ) );


      Log( "Omnia :: _triggerBookmarkItemBtn(), time:", time );
      Log( "  _isTouchEvent:", _isTouchEvent );

      _bs.broadcast( `bookmark-item-${id}-btn-${_actionTrigger()}` );

      _mi.currentTime( time );
      _mi.SEEKTRIGGERED.dispatch();

      if( _mi.paused() )
        _mi.PLAYTRIGGERED.dispatch();

      // hide controls, if touched
      if( _isTouchEvent ) 
      { 
        _hideMenus(); 
        _hide(); 
      }
    }
    //--------------------------------------------------------------------------
    function _triggerCaptionLangBtn( $btn )
    {
      // validate $btn
      if( !$btn.hasClass( "omnia-caption-track-select-btn" ) )
        return;

      var id = $btn.attr( "data-id" );

      Log( "Omnia :: _triggerCaptionLangBtn(), id:", id );

      _bs.broadcast( `caption-lang-${id}-selection-btn-${_actionTrigger()}` );

      // toggle caption visiblity
      ( id === "off" )
        ? _$ctnr.removeClass( _css.toggles.captions_on )
        : _$ctnr.addClass( _css.toggles.captions_on );

      // select caption language in caption menu
      _$captionTrackSelectList.find( "button.selected" ).removeClass( "selected" );
      $btn.addClass( "selected" );

      // select caption track that gets displayed
      _$captionTracks
        .removeClass( "selected" )
        .filter( `[data-id='${id}']` )
        .addClass( "selected" );
    }
    //--------------------------------------------------------------------------
    function _triggerQualityLevelBtn( $btn )
    {
      // validate $btn
      if( !$btn.hasClass( "omnia-quality-level-select-btn" ) )
        return;

      var id = $btn.attr( "data-id" );
      Log( "Omnia :: _triggerQualityLevelBtn(), id:", id );

      _bs.broadcast( `quality-level-${id}-selection-btn-${_actionTrigger()}` );
      _mi.QUALITYLEVELTRIGGERED.dispatch( id );
    }
    //--------------------------------------------------------------------------
    function _triggerAddonBtn( $btn )
    {
      Log( "Omnia :: _triggerAddonBtn()" );
      var aid = $btn.attr( "data-aid" );
      _bs.broadcast( `addon-${aid}-btn-${_actionTrigger()}` );
      c.Megaphone.Signals.AddonSignals.TRIGGERED.dispatch( aid );
    }
    //--------------------------------------------------------------------------
    function _triggerSeekStart( px )
    {
      Log( "Omnia :: _triggerSeekStart()" );

      // throttle seek callbacks, so browser doesn't crash
      _throttledSeekCB = c.utils.Throttle( 
        _mi.SEEKTRIGGERED.dispatch, 200 
      );
      _throttledBroadcast = c.utils.Throttle( function() {
        _bs.broadcast( "seek-scrubber-btn-dragging" );
      }, 200 );


      // set the scrubbing flag
      _isScrubbingSeek = true;
      _setHoverProgressUI( -1 );

      _triggerSeek( px, true, false );

      // notify
      _bs.broadcast( "seek-bar-" + _actionTrigger() );
    }
    //--------------------------------------------------------------------------
    function _triggerSeek( px, callback = true, broadcast = true )
    {
      Log( "Omnia :: _triggerSeek(), px:", px, "cb:", callback, "bc:", broadcast );

      // calculate percent based on pointer position relative to seek bar width
      var rect = _$seekBar[0].getBoundingClientRect();
      px      -= rect.left;
      var p    = px / rect.width;

      // keep percent between 0 and 1
      p = p < 0 ? 0 : p > 1 ? 1 : p; 

      // time
      var t = p * _duration;

      _mi.currentTime( t );
      _timeline.seek( t );
      _setProgressBarUI( p );
      _setSeekThumbUI( p );
      _setVideoProgressAria( t );

      // broadcast the event, if asked to
      !!broadcast && _throttledBroadcast.apply();
      !!callback && _throttledSeekCB.apply();
    }
    //--------------------------------------------------------------------------
    function _triggerSeekEnd()
    {
      Log( "Omnia :: _triggerSeekEnd()" );

      // set UI
      _setSeekThumbUI( -1 );
      _isScrubbingSeek = false;

      // ****************
      // COMMENTED OUT ON 21.01.22 - a stutter in the audio was being caused by
      // a seek being issued on mouse down AND mouse up. removing this was a
      // remedy.
      // ****************

      // seeking is done
      // _throttledSeekCB.apply();
      // _mi.SEEKENDTRIGGERED.dispatch();

      // hide controls, if touched
      // if( _isTouchEvent ) { _delayedHide( _data.activity_hide_delay / 2 ); }
    }
    //--------------------------------------------------------------------------
    function _triggerPlayscreenBtn()
    {
      Log( "Omnia :: _triggerPlayscreenBtn()" );
      if( _mi.paused() )
      {
        _bs.broadcast( "playpausescreen-play-btn-" + _actionTrigger() );
        _mi.PLAYTRIGGERED.dispatch();
      }
      else
      {
        _bs.broadcast( "playpausescreen-pause-btn-" + _actionTrigger() );
        _mi.PAUSETRIGGERED.dispatch();
      }
    }
    //--------------------------------------------------------------------------
    function _triggerCenterFovBtn()
    {
      Log( "Omnia :: _triggerCenterFovBtn()" );
      _bs.broadcast( "vr-centerfov-btn-" + _actionTrigger() );
      _mi.VRCAMERAPOSITIONTRIGGERED.dispatch({x:0,y:0,z:0});
    }
    //--------------------------------------------------------------------------
    function _triggerPermitGyroBtn()
    {
      Log( "Omnia :: _triggerPermitGyroBtn()" );
      _bs.broadcast( "vr-gyro-enable-btn-" + _actionTrigger() );

      // make a call to enable. the library handles everything (like the check 
      // and request for permissions)
      c.Gyro.child.enable()
        .then( () => 
          {
            Log( "  Gyro.child.enable().then..." );
            // what we need to do on a successful enable also gets done on an 
            // unsuccessful enable, so let .finally() below handle it...
          })
        .catch( e =>
          {
            Log( "  Gyro.child.enable().catch..." );
            Log( "    e:", e );
            // do something here with the error code? 
          })
        .finally( () =>
          {
            Log( "  Gyro.child.enable().finally..." );

            // remove handler, and then hide the button
            _$btnPermitGyro
              .off( "touchstart click" )
              .removeClass( "show" );

            if( c.Gyro.child.state() !== c.Gyro.States.INACTIVE )
            {
              _$btnToggleGyro
                .prop( "disabled", null );
            }

            // remove 360 indicator
            _$vrIndicatorCtnr.removeClass( "show" );
          });

    } 
    //--------------------------------------------------------------------------
    function _triggerToggleGyroBtn()
    {
      Log( "Omnia :: _triggerToggleGyroBtn()" );
      _bs.broadcast( "vr-gyro-toggle-btn-" + _actionTrigger() );

      Log( "  disabling toggle button..." );
      _$btnToggleGyro
        .prop( "disabled", true )
        .removeClass( "off" );

      Log( "  Gyro.child.state:", c.Gyro.child.state() );
      if( c.Gyro.child.state() === c.Gyro.States.IDLE )
      {
        Log( "  enabling..." );
        c.Gyro.child.enable()
          .then( () => { Log( "  Gyro.child.enable().then..." ); })
          .catch( e => { Log( "  Gyro.child.enable().catch... , e:", e ); })
          .finally( () =>
            {
              Log( "  Gyro.child.enable().finally..." );
              _$btnToggleGyro
                .attr( "aria-label", "Disable Gyro" )
                .prop( "disabled", null );
            });
      }
      else
      {
        Log( "  disabling..." );
        c.Gyro.child.disable()
          .then( () => { Log( "  Gyro.child.disable().then..." ); })
          .catch( e => { Log( "  Gyro.child.disable().catch... , e:", e ); })
          .finally( () =>
            {
              Log( "  Gyro.child.disable().finally..." );
              _$btnToggleGyro
                .attr( "aria-label", "Enable Gyro" )
                .prop( "disabled", null )
                .addClass( "off" );
            });
      }
    }

    // UI input listeners
    //--------------------------------------------------------------------------
    function _onPointerdown_playpause( e )
    {
      Log( "Omnia :: _onPointerdown_playpause()" );
      Log( "  target:", e.target );
      Log( "  currTarget:", e.currTarget );

      e.preventDefault();
      _hideMenus( "bookmarks" );
      _triggerPlaypauseBtn();
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_volume( e )
    {
      Log( "Omnia :: _onPointerdown_volume(), type:", e.type );
      e.preventDefault();
      _killAutoplayMutedUI();
      _hideMenus( "bookmarks" );
      _triggerVolumeBtn();
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_fullscreen( e )
    {
      Log( "Omnia :: _onPointerdown_fullscreen()" );
      e.preventDefault();
      _triggerFullscreenBtn();
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_seekback( e )
    {
      Log( "Omnia :: _onPointerdown_seekback()" );
      e.preventDefault();
      _hideMenus( "bookmarks" );
      _triggerSeekbackBtn();
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_seekforw( e )
    {
      Log( "Omnia :: _onPointerdown_seekforw()" );
      e.preventDefault();
      _hideMenus( "bookmarks" );
      _triggerSeekforwBtn();
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_captions( e )
    {
      Log( "Omnia :: _onPointerdown_captions(), e.target:", e.target );
      e.preventDefault();
      _hideMenus( "captions" );
      _triggerCaptionsBtn();
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_captionTrackSelectCtnr( e ) 
    {
      if( e.target !== _$captionTrackSelectCtnr[0] ) 
        return;

      Log( "Omnia :: _onPointerdown_captionTrackSelectCtnr(), closing selection menu..." );
      e.preventDefault();
      _hideMenus();
      // _delayedHide();
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_bookmarks( e )
    {
      Log( "Omnia :: _onPointerdown_bookmarks()" );
      e.preventDefault();
      _hideMenus( "bookmarks" );
      _triggerBookmarksBtn();
    }

    //--------------------------------------------------------------------------
    function _onPointerdown_settings( e )
    {
      Log( "Omnia :: _onPointerdown_settingsCtnr()" );
      e.preventDefault();
      _hideMenus( "settings" );
      _triggerSettingsBtn();
    }    
    //--------------------------------------------------------------------------
    function _onPointerdown_settingsCtnr( e )
    {
      if( e.target !== _$settingsCtnr[0] ) 
        return;
      Log( "Omnia :: _onPointerdown_settingsCtnr(), closing selection menu..." );
      e.preventDefault();
      _hideMenus();
      // _delayedHide();
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_playscreen( e )
    {
      Log( "Omnia :: _onPointerdown_playscreen()" );
      e.preventDefault();
      _triggerPlayscreenBtn();
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_autoplaymuted( e )
    {
      Log( "Omnia :: _onPointerdown_autoplaymuted()" );
      e.preventDefault();
      _triggerAutoplayUnmuteBtn();
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_bookmarkCtnr( e ) 
    {
      if( e.target !== _$bookmarkCtnr[0] ) 
        return;
      Log( "Omnia :: _onPointerdown_bookmarkCtnr(), closing selection menu..." );
      e.preventDefault();
      _hideMenus();
      // _delayedHide();
    }
    //--------------------------------------------------------------------------
    function _onMouseover_bookmarkItem( e )
    {
      if( _isTouchEvent ) return;

      var $t = c.$( this );
      Log( "Omnia :: onMouseover_bookmarkItem(), t:", $t );
      $t.parent().append( $t );
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_bookmarkItem( e )
    {
      Log( "Omnia :: _onPointerdown_bookmarkItem(), e.type:", e.type );
      e.preventDefault();
      _triggerBookmarkItemBtn( c.$( this ) );
    }
    //--------------------------------------------------------------------------
    function _onClick_captionselect( e )
    {
      Log( "Omnia :: _onClick_captionselect()" );
      e.preventDefault();
      _triggerCaptionLangBtn( c.$( this ) );
    }
    //--------------------------------------------------------------------------
    function _onClick_qualityselect( e )
    {
      Log( "Omnia :: _onClick_qualityselect()" );
      e.preventDefault();
      _triggerQualityLevelBtn( c.$( this ) );
    }
    //--------------------------------------------------------------------------
    function _onKeydown_doc( e )
    {
      Log( "Omnia :: _onKeydown_doc(), key:", e.key );
      _isKeyboardEvent = true;

      switch( e.key )
      {
        case "ArrowLeft":
        case "Left":
        case "ArrowDown":
        case "Down":
          // Log( "Omnia :: _onKeydown_doc(), key:", e.key, "ae:", document.activeElement );

          // is focus on volume bar?
          if( _isFocusOn( [ _$volSeekBar, _$btnVolumeScrubber ] ) )
          {
            _bs.broadcast( "volume-scrubber-keyed" );
            _setVolumeByDelta( -.05 );
            // _delayedHide();
          }
          // is focus on seek bar?
          else if( _isFocusOn( _$seekBar ) )
          {
            _bs.broadcast( "seek-scrubber-keyed" );
            _setSeekByDelta( -_data.seek_delta );
            // _delayedHide();
          }
          // was the left arrow pressed?
          else if( e.key === "ArrowLeft" )          
          {
            _bs.broadcast( "seek-keyed" );
            _setSeekByDelta( -_data.seek_delta );
            // _delayedHide();
          }
          break;

        case "Space":
        case "Spacebar":
        case " ":
        case "Enter":
          // Log( "Omnia :: _onKeydown_doc(), key:", e.key );

          var $ae = c.$( document.activeElement );

          // is focus on an <a> tag with an href?
          if( $ae.attr( "href" ) )
          {
            e.preventDefault();
            _bs.broadcast( "logo-link-keyed" );
            $ae[0].click();
            // _delayedHide();
          }
          // is focus on a button with a trigger function that was previously set up?
          else if( $ae.data( "trigger" ) )
          {
            e.preventDefault();
            $ae.data( "trigger" ).apply( null, [ $ae ] );
            // _delayedHide();
          }
          else if( _isFocusOn( _$volSeekBar ) ) 
          {
            e.preventDefault();
            _triggerVolumeBtn();
            // _delayedHide();
          }
          else
          {
            // nothing that requires special attention has focus, so let's only
            // allow the space bar to trigger a play/pause action
            if( e.key !== "Enter" )
            {

              if( _mi.paused() ) 
              {
                _$btnPlayScreen.blur();
                
                _bs.broadcast( "play-keyed" );
                _mi.PLAYTRIGGERED.dispatch();

              }
              else
              {
                _bs.broadcast( "pause-keyed" );
                _mi.PAUSETRIGGERED.dispatch();
              }
            }
          }

          break;

        case "ArrowRight":
        case "Right":
        case "ArrowUp":
        case "Up":
          // Log( "Omnia :: _onKeydown_doc(), key:", e.key, "ae:", document.activeElement );

          // is focus on volume bar?
          if( _isFocusOn( [ _$volSeekBar, _$btnVolumeScrubber ] ) )
          {
            _bs.broadcast( "volume-scrubber-keyed" );
            _setVolumeByDelta( .05 );
            // _delayedHide();
          }
          // is focus on seek bar? or, was the right arrow pressed?
          else if( _isFocusOn( _$seekBar ) )
          {
            _bs.broadcast( "seek-scrubber-keyed" );
            _setSeekByDelta( _data.seek_delta );
            // _delayedHide();
          }
          // was the right arrow pressed?
          else if( e.key === "ArrowRight" )          
          {
            _bs.broadcast( "seek-keyed" );
            _setSeekByDelta( _data.seek_delta );
            // _delayedHide();
          }

          break;

        case "Tab":

          _show();
          // _delayedHide();

          // _bs.broadcast( "tab-key-pressed" );

          // var killE = false;

          // // trying to maintain a natural forward order of tabbing without 
          // // using tabIndex
          // if( !e.shiftKey )
          // {
          //   if( _isFocusOn( _$btnFullscreen ) )
          //     _$btnDummy.focus();

          //   if( _isFocusOn( _listCaptionLangBtns[_listCaptionLangBtns.length-1] ) )
          //   {
          //     killE = true 
          //     if( _capabilities.fullscreen )
          //       _$btnFullscreen.focus();
          //     else
          //       _$btnDummy.focus();
          //   }

          //   if( _isFocusOn( _$btnCaptions ) )
          //     killE = true && _listCaptionLangBtns[0].focus();

          //   if( _isFocusOn( _listBookmarkItemBtns[_listBookmarkItemBtns.length-1] ) )
          //   {
          //     killE = true;
          //     if( _capabilities.captions )
          //       _$btnCaptions.focus();
          //     else if( _capabilities.fullscreen )
          //       _$btnFullscreen.focus();
          //     else
          //       _$btnDummy.focus();
          //   }

          //   if( _isFocusOn( _$btnBookmarks ) )
          //     killE = true && _listBookmarkItemBtns[0].focus();

          //   if( _isFocusOn( _$volSeekBar ) )
          //   {
          //     killE = true;
          //     if( _capabilities.bookmarks )
          //       _$btnBookmarks.focus();
          //     else if( _capabilities.captions )
          //       _$btnCaptions.focus();
          //     else if( _capabilities.fullscreen )
          //       _$btnFullscreen.focus();
          //     else
          //       _$btnDummy.focus();
          //   }
          // }
          // // trying to maintain a natural backward order of tabbing without 
          // // using tabIndex
          // else
          // {
          //   if( _isFocusOn( _listBookmarkItemBtns[0] ) )
          //     killE = true && _$btnBookmarks.focus();

          //   if( _isFocusOn( _$btnCaptions ) )
          //   { 
          //     killE = true 
          //     if( _capabilities.bookmarks )
          //       _listBookmarkItemBtns[_listBookmarkItemBtns.length-1].focus();
          //     else
          //       _$volSeekBar.focus();
          //   }

          //   if( _isFocusOn( _listCaptionLangBtns[0] ) )
          //     killE = true && _$btnCaptions.focus();

          //   if( _isFocusOn( _$btnFullscreen ) )
          //   {
          //     killE = true 
          //     if( _capabilities.captions )
          //       _listCaptionLangBtns[_listCaptionLangBtns.length-1].focus();
          //     else if( _capabilities.bookmarks )
          //       _listBookmarkItemBtns[_listBookmarkItemBtns.length-1].focus();
          //     else
          //       _$volSeekBar.focus();
          //   }

          //   if( _isFocusOn( _$btnDummy ) )
          //   {
          //     killE = true 
          //     if( _capabilities.fullscreen )
          //       _$btnFullscreen.focus();
          //     else if( _capabilities.captions )
          //       _listCaptionLangBtns[_listCaptionLangBtns.length-1].focus();
          //     else if( _capabilities.bookmarks )
          //       _listBookmarkItemBtns[_listBookmarkItemBtns.length-1].focus();
          //     else
          //       _$volSeekBar.focus();
          //   }
          // }

          // if( killE )
          // {
          //   e.preventDefault();
          //   e.stopPropagation();
          // }

          Log( "Omnia :: _onKeydown_doc(), Ended." );
          break;
      }
    }
    //--------------------------------------------------------------------------
    function _onFocusin_doc( e )
    {
      if( !_isKeyboardEvent )
        return;

      var ae = document.activeElement;
      Log( "Omnia :: _onFocusin_doc(), ae:", ae );

      _show();
      // _delayedHide();

      // show/hide caption language select menu depending on ae focus
      if( _isFocusOn( _listCaptionLangBtns ) )
      {
        _$ctnr.addClass( _css.toggles.captions_select )
        _$btnCaptions.attr( "aria-expanded", true );
      }
      else
      {
        _$ctnr.removeClass( _css.toggles.captions_select );
        _$btnCaptions.attr( "aria-expanded", false );
      }

      // show/hide bookmarks depending on ae focus
      _isFocusOn( _listBookmarkItemBtns )
        ? _$ctnr.addClass( _css.toggles.bookmarks_on )
        : _$ctnr.removeClass( _css.toggles.bookmarks_on );

      // show/hide volume seek bar depending on ae focus
      if( _isFocusOn( [ _$btnVolume, _$volSeekBar, _$btnVolumeScrubber ] ) )
      {
        _$volumeCtnr.addClass( _css.toggles.focused )
        _$btnVolume.attr( "aria-expanded", true );
      }
      else
      {
        _$volumeCtnr.removeClass( _css.toggles.focused );  
        _$btnVolume.attr( "aria-expanded", false );
      }

      // set delayed hide
      _isFocusOn( _$btnDummy ) && _hide();


      _isKeyboardEvent = false;
    }
    //--------------------------------------------------------------------------
    function _onMousemove_timeline( e )
    {
      if( _isTouchEvent ) return;
      if( _isScrubbingSeek ) return;

      // if( e.target !== _$timelineCtnr[0] ) return;

      // calculate percentage based on mouse position
      var rect = _$timelineCtnr[0].getBoundingClientRect();
      var mx = e.clientX - rect.left;
      var p = mx / rect.width;
      p = p > 1 ? 1 : p < 0 ? 0 : p;

      // Log( "Omnia :: _onMousemove_timeline()" );

      // set stuff
      _setHoverProgressUI( p );
    }
    //--------------------------------------------------------------------------
    function _onMouseleave_timeline( e )
    {
      if( _isTouchEvent ) return;
      Log( "Omnia :: _onMouseleave_timeline()" );

      if( !_isScrubbingSeek )
        _setHoverProgressUI( -1 );
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_seekscrubber( e )
    {
      Log( "Omnia :: _onPointerdown_seekscrubber()" );

      e.preventDefault();

      _triggerSeekStart( e.clientX || e.touches[0].clientX );

      // add move and end handlers
      c.$( window ).on( "touchmove mousemove",      _onPointermove_timeline );
      c.$( window ).on( "touchend mouseup dragend", _onPointerup_timeline );
      c.$( window ).on( "blur",                     _onPointerup_timeline );
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_timeline( e )
    {
      Log( "Omnia :: _onPointerdown_timeline()" );

      e.preventDefault();

      _triggerSeekStart( e.clientX || e.touches[0].clientX );

      // add move and end handlers
      c.$( window ).on( "touchmove mousemove",      _onPointermove_timeline );
      c.$( window ).on( "touchend mouseup dragend", _onPointerup_timeline );
      c.$( window ).on( "blur",                     _onPointerup_timeline );
    }
    //--------------------------------------------------------------------------
    function _onPointermove_timeline( e )
    {
      // double check we're scrubbing the seekbar
      if( !_isScrubbingSeek ) return;

      // e.preventDefault();

      _triggerSeek( e.pageX || e.touches[0].pageX );
    }
    //--------------------------------------------------------------------------
    function _onPointerup_timeline( e )
    {
      Log( "Omnia :: _onPointerup_timeline()" );

      e && e.preventDefault();

      _triggerSeekEnd();

      // kill listeners
      c.$( window ).off( "touchend mouseup dragend", _onPointerup_timeline );
      c.$( window ).off( "blur",                     _onPointerup_timeline );
      c.$( window ).off( "mousemove touchmove",      _onPointermove_timeline );
    }  
    //--------------------------------------------------------------------------
    function _onMousedown_volumebar( e )
    {
      Log( "Omnia :: _onMousedown_volumebar()" );
      e.preventDefault();

      // event broadcast
      _bs.broadcast( "volume-bar-" + _actionTrigger() );

      // set the scrubbing flag
      _isScrubbingVolume = true;

      // calculate the percentage of the mouse X-pos on the volume bar
      var rect = _$volSeekBar[0].getBoundingClientRect();
      var mx   = e.clientX - rect.left;
      var v    = mx / rect.width;
      v = v < 0 ? 0 : v > 1 ? 1 : v; 

      _mi.volume( v );
      _mi.VOLUMETRIGGERED.dispatch();

      if( v === 0 )
      {
        if( !_mi.muted() )
        {
          c.Megaphone.MediaInterface.muted( true );
          _mi.MUTETRIGGERED.dispatch();
        }
      }
      else
      {
        if( _mi.muted() )
        {
          c.Megaphone.MediaInterface.muted( false );
          _mi.MUTETRIGGERED.dispatch();
        }
      }

      c.$( window ).on( "mousemove",       _onMousemove_volumebar );
      c.$( window ).on( "mouseup dragend", _onMouseup_volumebar );
      c.$( window ).on( "blur",            _onMouseup_volumebar );

      // throttle the callbacks to seek, so the browser doesn't crash
      _throttledVolumeCB = c.utils.Throttle( _mi.VOLUMETRIGGERED.dispatch, 200 );
      _throttledBroadcast = c.utils.Throttle( function() {
        _bs.broadcast( "volume-scrubber-btn-dragging" );
      }, 200 );

      return( false );
    }
    //--------------------------------------------------------------------------
    function _onMousemove_volumebar( e )
    {
      // double check we're scrubbing the seekbar
      if( !_isScrubbingVolume ) return;

      // broadcast the event
      _throttledBroadcast.apply();

      // calculate the percentage of the mouse X-pos on the volume bar
      var rect = _$volSeekBar[0].getBoundingClientRect();
      var mx   = e.clientX - rect.left;
      var v    = mx / rect.width;
      v = v < 0 ? 0 : v > 1 ? 1 : v; 

      // Log( "Omnia :: _onMousemove_volumebar(), v:", v );

      // adjust volume
      _mi.volume( v );
      _mi.VOLUMETRIGGERED.dispatch();

      if( v === 0 )
      {
        if( !_mi.muted() )
          _mi.MUTETRIGGERED.dispatch();
      }
      else
      {
        if( _mi.muted() )
          _mi.MUTETRIGGERED.dispatch();
      }
    }
    //--------------------------------------------------------------------------
    function _onMouseup_volumebar( e )
    {
      Log( "Omnia :: _onMouseup_volumebar()" );

      e.preventDefault();

      // kill listeners
      c.$( window ).off( "mousemove",       _onMousemove_volumebar );
      c.$( window ).off( "mouseup dragend", _onMouseup_volumebar );
      c.$( window ).off( "blur",            _onMouseup_volumebar );

      _isScrubbingVolume = false;
    }  
    //--------------------------------------------------------------------------
    function _onPointerdown_addonbtn( e )
    {
      var $btn = c.$( this );
      var aid = $btn.attr( "data-aid" );

      Log( "Omnia :: _onPointerdown_addonbtn() - aid:" + aid );

      e.preventDefault();
      _triggerAddonBtn( $btn );
    }
    //--------------------------------------------------------------------------
    function _onPointerdown_centerfov( e )
    {
      Log( "Omnia :: _onPointerdown_centerfov()" );
      e.preventDefault();
      _triggerCenterFovBtn();
    }
    //--------------------------------------------------------------------------
    function _onPointerup_permitGyro( e )
    {
      Log( "Omnia :: _onPointerup_permitGyro()" );
      e.preventDefault();
      _triggerPermitGyroBtn();
    }
    //--------------------------------------------------------------------------
    function _onPointerup_toggleGyro( e )
    {
      Log( "Omnia :: _onPointerup_toggleGyro()" );
      e.preventDefault();
      _triggerToggleGyroBtn();
    }


    // show/hide/timer functionality    
    //--------------------------------------------------------------------------
    function _show()
    {
      // Log( "Omnia :: _show()" );
      _clearHideDelay();
      _$ctnr.addClass( _css.toggles.show );
      _$chrome.on( "touchend", _onTouchend_chrome );
      _isShowing = true; 
    }
    //--------------------------------------------------------------------------
    function _hide()
    {
      // Log( "Omnia :: _hide()" );
      _clearHideDelay();
      _$ctnr.removeClass( _css.toggles.show );
      _hideMenus( "bookmarks" );
      _$chrome.off( "touchend", _onTouchend_chrome );
      _isShowing = false;
    }
    //--------------------------------------------------------------------------    
    function _delayedHide( n )
    {
      // Log( "Omnia :: _delayedHide()" );
      if( !n ) n = _data.activity_hide_delay;

      _clearHideDelay(); 
      _timers.hide = setTimeout( _hide, n * 1000 );
    }
    //--------------------------------------------------------------------------
    function _clearHideDelay()
    {
      !!_timers.hide && clearTimeout( _timers.hide );
    }


    // ui handlers for show/hide
    //--------------------------------------------------------------------------
    function _onScroll_window( e ) 
    {
      Log( "Omnia :: _onScroll_window()" );
      _isScrolling = true;
    }
    //--------------------------------------------------------------------------
    function _onTouchstart_csimain_capture( e )
    {
      Log( "Omnia :: _onTouchstart_csimain_capture(), e:", e );
      Log( "  target:", e.target.nodeName.toLowerCase() );

      _isTouchEvent = true;

      // init vars for drag check later
      _touch.isDragging = false;
      _touch.x = Math.floor( e.touches[0].screenX );
      _touch.y = Math.floor( e.touches[0].screenY );

      // a delay was needed to not double unmute/mute when the automute or 
      // volume buttons are triggered as the first activity.
      setTimeout( function() {

        // unmute on first activity
        if( _data.unmute_on_activity )
        {
          _data.unmute_on_activity = false;
          _killAutoplayMutedUI();
          _mi.MUTETRIGGERED.dispatch();
        }
      }, 20 );
    }
    //--------------------------------------------------------------------------
    function _onTouchmove_csimain_capture( e )
    {
      // Stupid Android phones touch positions are so sensitive, like pixels 
      // with decimal points senstive. I needed a way to tone the sensitivity
      // way down. this did the trick. 

      // get the delta of touch position, rounded to the nearest integer
      const dx = Math.abs( _touch.x - Math.floor( e.touches[0].screenX ) );
      const dy = Math.abs( _touch.y - Math.floor( e.touches[0].screenY ) );

      // if the touch is within 5 pixels from the start position, it's not a
      // drag... yet.
      if( dx >= 5 || dy >= 5 )
        _touch.isDragging = true;
    }
    //--------------------------------------------------------------------------
    function _onTouchend_csimain_capture( e )
    {
      if( _isScrolling ) { setTimeout( function() { _isScrolling = false; }, 200 ); return; }

      // tap vs drag/swipe (a drag moves camera position in VR/360 media)
      let isTap = !_touch.isDragging;

      // reset
      _touch.isDragging = false;

      Log( "Omnia :: _onTouchend_csimain_capture(), isTap:", isTap );

      // ***********
      // FIX THIS LATER -- is the tap occuring on the media element and not a UI 
      // element (button) in the media's HTML? The VideoJS media has VR-related 
      // buttons that should probably be within a control bar and enabled via
      // the MediaInterface.
      // 
      // update 20.10.16: VR buttons moved from VideoJS media to Omnia add-on.
      // haven't removed this check yet, do more research into this before doing
      // so.
      let $media  = c.Megaphone.DOM.main.sel.children()[0];
      let isMedia = e && c.$.contains( $media, e.target );
      // ***********
  
      if( isTap && isMedia )
      {
        if( _isShowing )
          _hide()
        else 
        {
          _show();
          e.preventDefault();
        }
      }
    }   
    //--------------------------------------------------------------------------
    function _onTouchend_chrome( e )
    {
      // if( _isScrolling ) { return; }
      // Log( "Omnia :: _onTouchend_chrome(), e.type:", e.type, "isScrolling:", _isScrolling );

      // if( e.currentTarget === _$chrome[0] && _isShowing )
      // {
      //   e.preventDefault();
      //   _hide();
      // }
    } 
    //--------------------------------------------------------------------------
    function _onMousedown_chrome( e )
    {
      // if( _isTouchEvent ) return;

      // Log( "Omnia :: _onMousedown_chrome(), e.type:", e.type );

      // if( _mi.playing() )
      //   _mi.PAUSETRIGGERED.dispatch();
      // else
      //   _mi.PLAYTRIGGERED.dispatch();
    }
    //--------------------------------------------------------------------------
    function _onClick_csimain( e )
    {
      Log( "Omnia :: _onClick_csimain(), isTouchEvent:", _isTouchEvent );
      _isTouchEvent = false;
    }
    //--------------------------------------------------------------------------
    function _onMousedown_csimain( e )
    {
      if( _isTouchEvent ) return;

      Log( "Omnia :: _onMousedown_csimain()" );

      _mouse.isDown = true;
      _mouse.x = e.screenX;
      _mouse.y = e.screenY;
    }
    //--------------------------------------------------------------------------
    function _onMouseup_csimain( e )
    {
      if( _isTouchEvent ) return;

      Log( "Omnia :: _onMouseup_csimain(), e:", e );

      // a click is a mousedown/mouseup action with no movement
      let isClick = ( _mouse.x === e.screenX && _mouse.y === e.screenY );

      let $media  = c.Megaphone.DOM.main.sel.children()[0];
      let isMedia = e && c.$.contains( $media, e.target );

      Log( "Omnia :: _onMouseup_csimain(), isClick:", isClick );

      if( isClick && isMedia )
      {
        // if( _mi.playing() )
        //   _mi.PAUSETRIGGERED.dispatch();
        // else
        //   _mi.PLAYTRIGGERED.dispatch();

        _isShowing 
          ? _hide() 
          : _show();
      }

      // a delay was needed to not double unmute/mute when the automute or 
      // volume buttons are triggered as the first activity.
      setTimeout( function() {

        // unmute on first activity
        if( _data.unmute_on_activity )
        {
          _data.unmute_on_activity = false;
          _killAutoplayMutedUI();
          _mi.MUTETRIGGERED.dispatch();
        }
      }, 20 );

      _mouse.isDown = false;
    }
    //--------------------------------------------------------------------------
    function _onMousemove_csimain( e )
    {
      if( _isTouchEvent ) return;

      // Log( "Omnia :: _onMousemove_csimain(), mouse.isDragging:", _mouse.isDown );
      if( !_mouse.isDown )
      {
        _show();
        // _delayedHide();
      }
    }
    //--------------------------------------------------------------------------
    function _onMouseleave_ctnr( e ) 
    {
      if( _isTouchEvent ) return;

      Log( "Omnia :: _onMouseleave_ctnr()" );

      if( _isShowing )
        _hide();

      // fixes bug where user could "drag" outside of the container
      if( _isScrubbingSeek )
        _killSeek();
    }
    //--------------------------------------------------------------------------
    function _killSeek()
    {
      Log( "Omnia :: _killSeek()" );
      _onPointerup_timeline();
      _onMouseup_csimain();
    }


    // media interface listeners
    //--------------------------------------------------------------------------
    function _onLoadingprogressed_mi()
    {
      // Log( "Omnia :: _onLoadingprogressed_mi()" );
      var percent = Math.round( _mi.loadProgress() * 100 );
      _$loadedBar.css({ "width": ( percent.toString() + "%" ) });
    }
    //--------------------------------------------------------------------------
    function _onBufferingstarted_mi() 
    {
      _$ctnr.addClass( "buffering" );
    }
    //--------------------------------------------------------------------------
    function _onBufferingended_mi()
    {
      _$ctnr.removeClass( "buffering" );
    }
    //--------------------------------------------------------------------------
    function _onTimeupdated_mi()
    {
      // Log( "Omnia :: _onTimeupdated_mi()" );
      if( !_isScrubbingSeek )
      {
        _setVideoProgressUI();
        _setVideoProgressAria();
      }
    }
    //--------------------------------------------------------------------------
    function _onPlayingstateentered_mi()
    {
      Log( "Omnia :: _onPlayingstateentered_mi()" );
      _setPlayerStateUI( _playerState.PLAYING );
      _setPlayerStateAria( _playerState.PLAYING );
      _timeline.play( _mi.currentTime() );
    }
    //--------------------------------------------------------------------------
    function _onSeekended_mi()
    {
      Log( "Omnia :: _onSeekended_mi()" );
      _timeline.seek( _mi.currentTime() );
    }
    //--------------------------------------------------------------------------
    function _onPaused_mi()
    {
      Log( "Omnia :: _onPaused_mi()" );
      _setPlayerStateUI( _playerState.PAUSED );
      _setPlayerStateAria( _playerState.PAUSED );
      _timeline.pause();
    }
    //--------------------------------------------------------------------------
    function _onMuted_mi()
    {
      Log( "Omnia :: _onMuted_mi(), muted:", _mi.muted() );
      _setVolumeIconUI();      
      _setVolumeSliderUI();
      _setVolumeAria();
    }
    //--------------------------------------------------------------------------
    function _onVolumeupdated_mi()
    {
      _setVolumeIconUI();
      _setVolumeSliderUI();
      _setVolumeAria();
    }
    //--------------------------------------------------------------------------
    function _onErrored_mi()
    {
      Log( "Omnia :: _onErrored_mi()" );
    }
    //--------------------------------------------------------------------------
    function _onCompleted_mi()
    {
      Log( "Omnia :: _onCompleted_mi()" );
      _setPlayerStateUI( _playerState.PAUSED );
      _setPlayerStateAria( _playerState.PAUSED );
      _timeline.pause();
    }
    //--------------------------------------------------------------------------
    function _onQualitylevelsadded_mi()
    {
      Log( "Omnia :: _onQualitylevelsadded_mi(), Fired." );
      Log( "  levels:", _mi.qualityLevels() );

      // loop through available quality levels...
      Object.keys( _mi.qualityLevels() ).forEach( ( key ) =>
        {
          var q = _mi.qualityLevels()[key];

          // quality already added
          if( _qualitiesAdded[q.id] )
            return;

          // add item to quality level select menu
          var $q = c.$( _tpl.qualityLevelSelect );
          _$qualityLevelSelectList.append( $q );

          // set caption lang button props
          var $btn = $q.find( "button" );
          $btn
            .html( q.label )
            .attr( "data-id", q.id )
            .attr( "aria-label", q.label + " Quality" )
            .on( "click", _onClick_qualityselect );

          _listQualityLevelBtns.push( $btn );
        });

      _capabilities.settings = true;

      // add "settings" as a capability (updates some UI in the CSS)
      _$ctnr.addClass( _css.capabilities.settings );

      Log( "Omnia :: _onQualitylevelsadded_mi(), Ended." );
    }
    //--------------------------------------------------------------------------
    function _onQualitylevelselected_mi()
    {
      var id = _mi.quality();
      Log( "Omnia :: _onQualitylevelselected_mi(), id:", id );

      // select quality level in settings menu
      _$qualityLevelSelectList.find( "button.selected" ).removeClass( "selected" );
      _$qualityLevelSelectList.find( `button[data-id='${id}']` ).addClass( "selected" );
    }
    //--------------------------------------------------------------------------
    function _onVrcamerapositionupdated_mi()
    {
      // vrCameraPosition is a THREEjs vector
      var pos = _mi.vrCameraPosition();

      // Convert vector to a heading, in radians, then to degrees, then adjust 
      // for THREEjs oddities (straight ahead is 180, not zero)
      var deg = (( Math.atan2( pos.x, pos.z ) * ( 180 / Math.PI ) + 180 ) * -1 ) % 360;

      // update the UI
      _setFovUI( deg );
    }


    // helper funcs
    //--------------------------------------------------------------------------
    function _updateDuration()
    {
      Log( "Omnia :: _updateDuration()" );

      // data
      _duration = _mi.duration();
      _timeline.remove( c.utils.Noop );
      _timeline.add( c.utils.Noop, _duration );
      _$scrubCtnr.attr( "aria-valuemax", _duration );

      // update UI
      _setRemainingTimeUI( _duration );
      _setTotalTimeUI( _duration );
      _setVolumeIconUI();
      _setVolumeSliderUI();
      _setBookmarkUI();
    }
    //--------------------------------------------------------------------------
    function _actionTrigger() 
    {
      if( _isTouchEvent )
        return "tapped";
      if( _isKeyboardEvent )
        return "keyed";
      return "clicked";
    }
    //--------------------------------------------------------------------------
    function _hideMenus( exempt )
    {
      Log( "Omnia :: _hideMenus()" );

      exempt !== "captions" &&
        _$ctnr.removeClass( _css.toggles.captions_select );

      exempt !== "bookmarks" &&
        _$ctnr.removeClass( _css.toggles.bookmarks_on );

      exempt !== "settings" &&
        _$ctnr.removeClass( _css.toggles.settings_select );
    }
    //--------------------------------------------------------------------------
    function _killAutoplayMutedUI()
    {
      Log( "Omnia :: _killAutoplayMutedUI()" );

      // remove pointer listener
      _$btnAutoplayUnmute.off( "touchstart mousedown", _onPointerdown_autoplaymuted );
      _$btnAutoplayUnmute.attr( "trigger", null );

      // remove tab handler
      _$btnAutoplayUnmute.attr( "tabIndex", "-1" );
      _$btnAutoplayUnmute.blur();

      // hide from UI
      _$autoplayMutedCtnr
        .addClass( "unmuted" )
        .removeClass( "show" );
    }
    //--------------------------------------------------------------------------
    function _isFocusOn( selectorOrArray )
    {
      // Log( "Omnia :: _isFocusOn(), selectorOrArray:", selectorOrArray );

      // is parameter truthy?
      if( !selectorOrArray )
        return false;

      // serialize input
      var arr = Array.isArray( selectorOrArray )
              ? selectorOrArray
              : [ selectorOrArray ];

      // check items
      for( var i = 0; i < arr.length; i++ )
        if( document.activeElement == arr[i][0] )
          return true;

      // item not focused
      return false;
    }
    //--------------------------------------------------------------------------
    function _setSeekByDelta( delta )
    {
      if( !delta || isNaN( delta ) ) return;

      var d = _duration;
      var t = _mi.currentTime() + delta;
      t = t < 0 ? 0 
        : t > d ? d
        : t;

      _timeline.time( t );

      _mi.currentTime( t );      
      _mi.SEEKTRIGGERED.dispatch();
    }
    //--------------------------------------------------------------------------
    function _setVolumeByDelta( delta )
    {
      if( !delta || isNaN( delta ) ) return;

      var max = 1;
      var vol = _mi.volume() + delta;
      vol = vol < 0 ? 0
          : vol > 1 ? 1
          : vol;

      _mi.volume( vol );
      _mi.VOLUMETRIGGERED.dispatch();
    }
    //--------------------------------------------------------------------------
    function _setVideoProgressUI()
    {
      // Log( "Omnia :: _setVideoProgressUI()" );

      var t = _mi.currentTime();
      var p = t / _duration;

      // progress bar
      _setProgressBarUI( p );
      _setVideoProgressAria( t );

      // current time
      _setCurrentTimeUI( t );
      _setRemainingTimeUI( _duration - t );
    }
    //--------------------------------------------------------------------------
    function _setProgressBarUI( percent )
    {
      var left  = percent >= 0 ? ( percent * 100 ).toString() + "%" : "-10000px";
      var width = percent >= 0 ? ( percent * 100 ).toString() + "%" : "0";

      _$progressBar.css({ width: width });
      _$btnSeekScrubber.css({ left : left });
    }
    //--------------------------------------------------------------------------
    function _setVideoProgressAria( time )
    {
      _$scrubCtnr.attr( "aria-valuenow", time );
    }
    //--------------------------------------------------------------------------
    function _setTotalTimeUI( time )
    {
      _$totalTime.html( c.utils.SecsToTimecode( time ) );
    }
    //--------------------------------------------------------------------------
    function _setRemainingTimeUI( time )
    {
      _$remainTime.html( c.utils.SecsToTimecode( time ) );
    }
    //--------------------------------------------------------------------------
    function _setCurrentTimeUI( time )
    {
      _$currentTime.html( c.utils.SecsToTimecode( time ) );
    }
    //--------------------------------------------------------------------------
    function _setHoverProgressUI( percent )
    {
      // Log( "Omnia :: _setHoverProgressUI(), percent:", percent );

      // set seeking bar position
      _$seekingBar.css({ width: ( percent < 0 ? "0": ( percent * 100 ).toString() ) + "%" });

      // set seekthumb properties
      _setSeekThumbUI( percent );
    }
    //--------------------------------------------------------------------------
    function _setSeekThumbUI( percent )
    {
      if( percent < 0 )
      {
        _$seekThumb.css({ left: "-1000%" });
        return;
      }

      // set thumb position
      var tlWidth     = _$timelineCtnr.outerWidth();
      var stWidth     = _$seekThumb.outerWidth() - 12;
      var stHalfWidth = stWidth / 2;
      var min         = stHalfWidth;
      var max         = tlWidth - stHalfWidth;
      var leftPer     = percent * 100;
      var leftPx      = percent * tlWidth;
      var left        = leftPer.toString() + "%";
      var ptrLeft     = "50%";
      var time        = percent * _duration;
      var cue         = _vtt.getCueForTime( "seekthumbs", time );
      var ctnrcss;

      // Log( "Omnia :: _setSeekThumbUI(), time:", time, "cue:", cue );


      // figure out if the thumb is beyond the bounds of the seek bar and adjust position/pointer
      if( leftPx < min )
      {
        left = stHalfWidth.toString() + "px";
        ptrLeft = "calc(50% - " + (stHalfWidth-leftPx).toString() + "px)";
      }
      if( leftPx > max )
      {
        left = ( tlWidth - stHalfWidth ).toString() + "px";
        ptrLeft = "calc(50% + " + (stHalfWidth-(tlWidth-leftPx)).toString() + "px)";
      }

      // positioning
      _$seekThumb.css({ left: left });
      _$seekThumbPtr.css({ left: ptrLeft });

      // time code
      _$seekThumbTime.html( c.utils.SecsToTimecode( time ) );

      // thumb img
      if( cue && cue.thumb )
      {
        // update the thumbnail, if needed
        if( _$seekThumbImg.attr( "src") !== cue.thumb.src )
          _$seekThumbImg.attr( "src", cue.thumb.src );

        // update the img's CSS 
        _$seekThumbImg.css( cue.thumb.css );

        // generate img container's CSS
        ctnrcss = { "width": `${cue.thumb.w}px`, "height" : `${cue.thumb.h}px` };
      }
      else
        // generate the img container's CSS
        ctnrcss = { "width": "0px", "height" : "0px" };

      // update the container's CSS
      _$seekThumbImgCtnr.css( ctnrcss );
    }
    //--------------------------------------------------------------------------
    function _setVolumeIconUI()
    {
      var m = _mi.muted();
      var v = _mi.volume();
      Log( "Omnia :: _setVolumeIconUI(), muted:", m, "volume:", v );

      if( m )
      {
        _$btnVolume
          .removeClass( "low med hi" )
          .addClass( "muted" );
      }
      else
      {
        _$btnVolume
          .removeClass( "muted low med hi" )
          .addClass( v === 0 ? "muted" :
                     v < .33 ? "low"   :
                     v < .67 ? "med"   : 
                     "hi" );
      }
    }
    //--------------------------------------------------------------------------
    function _setVolumeAria()
    {
      const VOLUME = _mi.muted() ? 0 : _mi.volume();
      Log( "Omnia :: _setVolumeAria(), v:", VOLUME );
      _$volumeBarsCtnr.attr( "aria-valuenow", VOLUME );
    }
    //--------------------------------------------------------------------------
    function _setVolumeSliderUI()
    {
      Log( "Omnia :: _setVolumeSliderUI()" );
      var m = _mi.muted();
      var v = _mi.volume();
      var p = ( v * 100 ) + "%";

      _$btnVolumeScrubber.css({ "left": ( m ? "0%" : p ) });
      _$volProgressBar.css({ "width": ( m ? "0%" : p ) });
    }
    //--------------------------------------------------------------------------
    function _setBookmarkUI()
    {
      Log( "Omnia :: _setBookmarkUI(), duration:", _duration );
      if( isNaN( _duration ) ) return;

      _bookmarks.items().forEach( ( bm ) =>
        {
          var $btn = _listBookmarkItemBtns.find( btn => btn.attr( "data-id" ) === bm.id );
          var $li  = $btn && $btn.parent();
          var left = ( Math.round( bm.time / _duration * 10000 ) / 100 ).toString() + "%";
          $li && $li.css({ "left" : left });
        });
    }
    //--------------------------------------------------------------------------
    function _setPlayerStateUI( state )
    {
      Log( "Omnia :: _setPlayerStateUI(), state:", state );

      var cls = "";

      switch( state )
      {
        case _playerState.PLAYING:   
          _$btnPlaypause.addClass( "playing" );
          cls = _css.state.playing;   
          break;
        case _playerState.PAUSED:    
          _$btnPlaypause.removeClass( "playing" );
          cls = _css.state.paused;    
          break;
        case _playerState.BUFFERING: 
          cls = _css.state.buffering; 
          break;
      }

      _$ctnr
        .removeClass( Object.values( _css.state ).join( " " ) )
        .addClass( cls ); 
    }
    //--------------------------------------------------------------------------
    function _setPlayerStateAria( state )
    {
      switch( state )
      {
        case _playerState.PLAYING:   
          _$btnPlaypause.attr( "aria-label", "Pause" );
          _$btnPlayScreen.attr( "aria-label", "Pause" );
          break;
        case _playerState.PAUSED:    
          _$btnPlaypause.attr( "aria-label", "Play" );
          _$btnPlayScreen.attr( "aria-label", "Play" );
          break;
      }
    }
    //--------------------------------------------------------------------------
    function _setFovUI( angle )
    {
      // rotate the center fov button according to theta
      _$btnCenterFov.css({ 
        transform: `rotate(${angle}deg)`
      });
    }
    //--------------------------------------------------------------------------
    function _toggleGyro()
    {
      Log( "VideoJS :: _toggleGyro(), old value:", _settings.isGyroEnabled );

      // *********************
      // stripped from VideoJS media.
      // needs cross talk to MI to VideoJS
      // *********************

      // _settings.isGyroEnabled = !_settings.isGyroEnabled;

      // if( _settings.isGyroEnabled )
      // {
      //   _vjs.vr().controls3d.orientation.connect();
      //   _$gyroBtn.removeClass( "off" )
      // }
      // else
      // {
      //   let v = _currVector.clone();
      //   _vjs.vr().controls3d.orientation.disconnect();
      //   _setCameraFOV( v.x, v.y, v.z );
      //   _$gyroBtn.addClass( "off" );
      // }
    }


    //==========================================================================
    // public interface
    //--------------------------------------------------------------------------
    return {

      // ***********************
      // REMOVE THIS LATER
      "_private" : {
      },

      // getters
      //------------------------------------------------------------------------
      get id()         { return( _id ); },
      get state()      { return( _state ); },

      // setters
      //------------------------------------------------------------------------
      set id( s )      { _id = s; },

      // methods
      //--------------------------------------------------------------------------
      "init" : init,
      "start" : start,
      "resize" : resize
    }


  })();

  // hoist to the "concat" namespace
  c.Megaphone.Addons.Items.push( Omnia );

})( window, document, window.concat );

